export default "__VITE_ASSET__68092593__"